import { render, staticRenderFns } from "./resourceApplyAdd.vue?vue&type=template&id=93a5357e&scoped=true&"
import script from "./resourceApplyAdd.vue?vue&type=script&lang=js&"
export * from "./resourceApplyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a5357e",
  null
  
)

export default component.exports